export enum TrafficReportLayerType {
  LEVEL_OF_SERVICE = 'LEVEL_OF_SERVICE',
  TRAFFIC_REPORT = 'TRAFFIC_REPORT',
}
